











































































































import Vue from "vue";
import userManager from "@/services/userManager";
import userRoles from "@/constants/userRoles";
import coreApiClient from "@/services/apis/coreApiClient";
import stateManager from "@common/services/stateManager";
import ganiAsiaTenantCodes from "@/constants/ganiAsiaTenantCodes";
import { setupAgentPlatformSdk, teardownAgentPlatformSdk } from "@/utils/agentPlatformSdk";

export default Vue.extend({
  data() {
    return {
      self: this,
      userManager,
      userRoles,
      mini: true,
      alertCount: 0,
      items: [
        {
          title: "Cảnh báo",
          icon: "fa-solid fa-bell",
          to: "/app/alerts",
          condition() {
            return userManager.checkRole(["admin", "kt"]) && !ganiAsiaTenantCodes.includes(userManager.tenantCode());
          },
          alert: true,
        },
        {
          title: "QL Quốc gia",
          icon: "fa-solid fa-globe",
          to: "/app/countries",
          condition() {
            return !userManager.checkRole(["telesale"], true);
          },
        },
        {
          title: "QL Thị trường",
          icon: "fas fa-globe-asia",
          to: "/app/markets",
        },
        {
          title: "QL Phòng",
          icon: "mdi-family-tree",
          to: "/app/departments",
          condition() {
            return userManager.checkRole(["admin", "kt"]);
          },
        },
        {
          title: "QL Teams",
          icon: "mdi-account-group",
          to: "/app/teams",
          condition() {
            return userManager.checkRole(["admin", "kt"]);
          },
        },
        {
          title: "QL Người dùng",
          icon: "mdi-account-circle",
          to: "/app/users",
          condition() {
            return userManager.checkRole(["admin", "kt", "ksnb", "ksnbl"]);
          },
        },
        {
          title: "Chi phí quảng cáo",
          icon: "mdi-advertisements",
          to: "/app/ads",
          condition() {
            return userManager.checkRole(["admin", "kt", "ksnb", "ksnbl", "mkt", "tp"]) && !ganiAsiaTenantCodes.includes(userManager.tenantCode());
          },
        },
        {
          title: "Thanh Toán",
          icon: "mdi-credit-card-outline",
          to: "/app/payment",
          condition() {
            return userManager.checkRole(["admin", "kt"]);
          },
        },
        {
          title: "Tổng thống kê quốc gia",
          icon: "mdi-chart-bar-stacked",
          to: "/app/country_statistics/",
          condition() {
            return userManager.checkRole(["kt", "vd", "vdl", "qlk"]) || ganiAsiaTenantCodes.includes(userManager.tenantCode());
          },
        },
        {
          title: "Tổng thống kê (Facebook)",
          icon: "mdi-chart-line",
          to: "/app/statistics/general",
          condition() {
            return !userManager.checkRole(["ksnb", "telesale"], true) && !ganiAsiaTenantCodes.includes(userManager.tenantCode());
          },
        },
        {
          title: "Tổng thống kê (TMDT)",
          icon: "mdi-chart-areaspline-variant",
          to: "/app/statistics/tmdt",
          condition() {
            return !userManager.checkRole(["telesale"], true) && !ganiAsiaTenantCodes.includes(userManager.tenantCode());
          },
        },
        {
          title: "Tổng thống kê (Khách sỉ)",
          icon: "mdi-chart-bar",
          to: "/app/statistics/wholesale",
          condition() {
            return userManager.checkRole(["kt"]) || (userManager.checkRole(["mkt"]) && ganiAsiaTenantCodes.includes(userManager.tenantCode()));
          },
        },
        {
          title: "Lịch sử hoạt động",
          icon: "mdi-clipboard-text-clock",
          to: "/app/action_logs",
          condition() {
            return userManager.checkRole(["admin", "kt"]);
          },
        },
        {
          title: "Cài đặt thưởng ngày",
          icon: "mdi-cash-multiple",
          to: "/app/daily_bonus_settings",
          condition() {
            return userManager.checkRole(["admin", "kt"]) && !ganiAsiaTenantCodes.includes(userManager.tenantCode());
          },
        },
        {
          title: "QL ĐV vận chuyển",
          icon: "mdi-truck-delivery",
          to: "/app/shipping_companies",
          condition() {
            return userManager.checkRole(["admin", "kt"]) && !ganiAsiaTenantCodes.includes(userManager.tenantCode());
          },
        },
        {
          title: "QL ĐV vận chuyển mua hàng",
          icon: "mdi-truck-cargo-container",
          to: "/app/purchase_shipping_companies",
          condition() {
            return userManager.checkRole(["admin", "kt"]);
          },
        },
        {
          title: "QL Loại tiền tệ mua hàng",
          icon: "mdi-currency-php",
          to: "/app/purchase_currencies",
          condition() {
            return userManager.checkRole(["admin", "kt"]);
          },
        },
        {
          title: "QL Nền tảng MKT",
          icon: "fab fa-facebook-square",
          to: "/app/mkt_platforms",
          condition() {
            return userManager.checkRole(["admin", "kt"]);
          },
        },
        {
          title: "Quản lý loại kênh KOC",
          icon: "mdi-broadcast",
          to: "/app/creator_channel_types",
          condition() {
            return userManager.checkRole(["admin", "kt"]) && !ganiAsiaTenantCodes.includes(userManager.tenantCode());
          },
        },
        {
          title: "Quản lý nguồn data",
          icon: "mdi-source-branch",
          to: "/app/data_sources",
          condition() {
            return userManager.checkRole(["admin", "kt"]);
          },
        },
        {
          title: "QL Phân loại SP",
          icon: "mdi-shape",
          to: "/app/product_categories",
          condition() {
            return userManager.checkRole(["admin", "kt"]);
          },
        },
        {
          title: "QL Chuyển kho",
          icon: "mdi-content-save-move",
          to: "/app/warehouse_transfer_commands",
          condition() {
            return userManager.checkRole(["kt", "qlk", "vdl", "vd"]) && !ganiAsiaTenantCodes.includes(userManager.tenantCode());
          },
        },
        {
          title: "FIFO",
          icon: "mdi-format-list-bulleted",
          to: "/app/fifo_ledger",
          condition() {
            return userManager.checkRole(["admin", "kt"]) && ganiAsiaTenantCodes.includes(userManager.tenantCode());
          },
        },
        {
          title: "Thay đổi cách bán",
          icon: "mdi-swap-horizontal",
          to: "/app/cost_modify_commands",
          condition() {
            return userManager.checkRole(["kt"]) && !ganiAsiaTenantCodes.includes(userManager.tenantCode());
          },
        },
        {
          title: "Chi phí",
          icon: "mdi-cash-100",
          to: "/app/monthly_costs",
          condition() {
            return userManager.checkRole(["admin", "kt"]);
          },
        },
        {
          title: "Lương",
          icon: "mdi-account-cash",
          to: "/app/salaries",
          condition() {
            return !ganiAsiaTenantCodes.includes(userManager.tenantCode());
          },
        },
        {
          title: "Cài đặt",
          icon: "mdi-cog-outline",
          to: "/app/setting",
          condition() {
            return userManager.checkRole(["admin", "kt"]) && !ganiAsiaTenantCodes.includes(userManager.tenantCode());
          },
        },
        {
          title: "Đổi mật khẩu",
          icon: "mdi-form-textbox-password",
          to: "/app/change_password",
        },
        {
          title: "Personal Access Tokens",
          icon: "mdi-key-variant",
          to: "/app/personal_access_tokens",
          condition() {
            return userManager.checkRole(["admin"]) && !!userManager.getUserInfo().super;
          },
        },
      ],
      userInfo: {},
      tenants: [
        {
          value: "",
          text: "TBestPro",
        },
        {
          value: "ganico",
          text: "Ganico",
        },
        {
          value: "tbestproGlobal",
          text: "TBestPro Global",
        },
      ],
    };
  },
  methods: {
    async logout() {
      userManager.deleteAccessToken();
      this.$router.push("/login");
    },
    visibleTenants() {
      if (window.location.host === "gani.asia") {
        return this.tenants.filter((tenant) => ganiAsiaTenantCodes.includes(tenant.value));
      }
      return this.tenants;
    },
    updateCurrentTenantCode(value) {
      stateManager.set("currentTenantCode", value);
      if (value === "ganico") {
        stateManager.set("CONFIG_PROVIDER_VUETIFY_OPTIONS", {
          theme: {
            themes: {
              light: {
                primary: "#9c27b0",
              },
            },
          },
        });
      } else {
        stateManager.delete("CONFIG_PROVIDER_VUETIFY_OPTIONS");
      }
      location.reload();
    },
  },
  beforeDestroy() {
    teardownAgentPlatformSdk();
  },
  async created() {
    this.userInfo = userManager.getUserInfo();
    setupAgentPlatformSdk();
    if (userManager.checkRole(["admin", "kt"]) || userManager.availableTenantCodes().length > 1) {
      this.currentTenantCode = userManager.tenantCode();
    }
    if (userManager.checkRole(["admin", "kt"])) {
      const { count } = await coreApiClient.call("alerts", "findAll", {
        payload: JSON.stringify({
          limit: -10,
          filters: [
            {
              key: "status",
              operator: "equal_to",
              value: "pending",
            },
            {
              key: "type",
              operator: "not_in",
              value: ["ladiPageOrderCount"],
            },
          ],
        }),
      });
      this.alertCount = count;
    }

    window.addEventListener("storage", (event) => {
      if (event.key === "currentTenantCode") {
        window.location.reload();
      }
    });
  },
});
